import { Tab, TabsNavigation } from "pepsico-ds";

import { useEffect, useState } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";

const HistoryLogsListPage = () => {
  const [selectedTab, setSelectedTab] = useState(0);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (location.pathname.includes("/history-logs-content")) {
      setSelectedTab(1);
    } else {
      setSelectedTab(0);
    }
  }, [location.pathname]);

  const handleTabChange = (index) => {
    setSelectedTab(index);
    if (index === 0) {
      navigate("/system-setting/history-logs");
    } else {
      navigate("/system-setting/history-logs-content");
    }
  };

  return (
    <div className="px-3">
      <div className="container-card">
        <div className="page-header">
          <h6 className="font-bold font-lg">History Logs</h6>
        </div>
        <TabsNavigation
          className="tabs-wrap"
          style={{ borderBottom: "2px solid #D7E5F8" }}
          onUpdate={handleTabChange}
          selectedIndex={selectedTab}
        >
          <Tab label="Campaigns" />
          <Tab label="Content Studio" />
        </TabsNavigation>
        <Outlet />
      </div>
    </div>
  );
};

export default HistoryLogsListPage;
